import { render, staticRenderFns } from "./ParticipantOrganizerAndMedia.vue?vue&type=template&id=a936aabc"
import script from "./ParticipantOrganizerAndMedia.vue?vue&type=script&lang=js"
export * from "./ParticipantOrganizerAndMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports